import { Box, List, MenuItem, Popover, Typography } from '@mui/material';
import { useTypedDispatch, useTypedSelector } from '../../reducers';

type Props = {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  open: boolean;
};

export default function UserPopover({ anchorEl, onClose, open }: Props) {
  const dispatch = useTypedDispatch();

  const { user } = useTypedSelector((state) => state.auth);

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      onClose={onClose}
      open={Boolean(open)}
    >
      <Box sx={{ p: 1.25, pb: 0 }}>
        <Typography>{user?.email}</Typography>
      </Box>
      <List sx={{ p: 1 }}>
        <MenuItem
          onClick={() =>
            dispatch({
              type: 'LOGOUT',
            })
          }
        >
          Log Out
        </MenuItem>
      </List>
    </Popover>
  );
}
